
import { mapState, mapGetters } from 'vuex'

export default {
  props: {
    item: { type: Object, required: true },
    filters: { type: Array, required: false, default: () => ([]) },
    filterHeight: { type: Number, required: true },
    headers: { type: Array, required: true },
    selectedFields: { type: Array, required: false, default: () => ([]) },
    pagination: { type: Object, required: true },
    truncate: { type: Number, default: 50 },
    noInteraction: { type: Boolean, default: false }
  },
  data () {
    return {
      hovered: {},
      detailDialog: {}
    }
  },
  computed: {
    ...mapState('dataset', ['dataset']),
    ...mapGetters('dataset', ['labelField', 'descriptionField']),
    shouldDisplayDetail () {
      return (field, itemValue) => {
        if (field['x-refersTo'] === 'http://schema.org/DigitalDocument') return false
        if (field['x-refersTo'] === 'https://schema.org/WebPage') return false
        return field.type === 'string' && !field.separator && itemValue && itemValue.length > 20
      }
    },
    otherHeaders () {
      return this.headers.filter(h => {
        if (!h.field) return false
        // if (this.descriptionField && this.descriptionField.key === f.key) return false
        if (this.labelField && this.labelField.key === h.value) return false
        return true
      })
    }
  },
  methods: {
    hover (value) {
      if (this.noInteraction) return
      this._hoverTimeout = setTimeout(() => { this.$set(this.hovered, value, true) }, 60)
    },
    leave (value) {
      if (this.noInteraction) return
      if (this._hoverTimeout) {
        clearTimeout(this._hoverTimeout)
        delete this._hoverTimeout
      }
      this.$delete(this.hovered, value)
    }
  }
}
